import { Injectable, ViewContainerRef } from '@angular/core';
import { BarcodeReaderComponent } from '@features/code-readers/barcode-reader/barcode-reader.component';
import { QrReaderComponent } from '@features/code-readers/qr-reader/qr-reader.component';
import { QRCode } from 'jsqr';

@Injectable({
  providedIn: 'root',
})
export class CodeReaderService {
  async readQR(host: ViewContainerRef): Promise<QRCode> {
    host.clear();

    const ref = host.createComponent(QrReaderComponent);
    try {
      return await ref.instance.startVideoStream();
    } finally {
      ref.destroy();
      host.clear();
    }
  }

  async readBarcode(host: ViewContainerRef) {
    host.clear();

    const ref = host.createComponent(BarcodeReaderComponent);
    try {
      return await ref.instance.startBarcodeScanner();
    } finally {
      ref.destroy();
      host.clear();
    }
  }

  async requestCameraAccess(): Promise<void> {
    if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') {
      throw new Error('Camera not supported.');
    }

    try {
      await navigator.mediaDevices.getUserMedia({ video: true });
    } catch (error) {
      console.error('Camera access denied:', error);
      throw new Error('Camera access denied. Please allow camera permissions.');
    }
  }
}
